import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Link} from "react-router-dom";
import axios from "axios";
import {confirmAlert} from 'react-confirm-alert';
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";
import { List } from 'react-virtualized';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class MerchantBrandIntegration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            loading: true,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            is_download: false,
            uploadDropdown: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            emiMenus:[],
            upload_user_type: null,
            merchant_mapping_table_data: [],
            tid:'',
            tenureList: [],
            tenureValue: [],
            bankList: [],
            bankValue: [],
            merchantList: [],
            merchantValue: [],
            chainValue: [],
            chainList: [],
            storeValue: [],
            storeList: [],
            chain_name_edit:'',
            merchant_name_edit:'',
            store_name_edit:'',
            bank_name_edit:'',
            tennure_name_edit:'',
            merchant_code_edit: '',
            chain_code_edit: '',
            store_code_edit:'',
            bank_code_edit:'',
            tennure_code_edit:'',
            tid_edit:'',
            config_id: null,
            add_disable:false,
            edit_disable:false,
            merchantID: '',
            chainID: '',
            storeID: '',
            merchantName:'',
            chainName:'',
            storeName:'',
            bankName:'',
            tenureName:'',
            merchantGroups:[],
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        this.getMerchantMappingData();
        this._getAllMerchants();
        this._getAllBankDetails();
        this._getMonthTenureFlexipay();
    }

    _getAllBankDetails(){
        axios.post(config.get('API_URL')+'/brandemi/get_bank_list',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((bank, index) => {
                    this.state.bankList.push({value: bank.issuer_bank_code, label: bank.issuer_bank_display_name})
                });
            }
        });
    }


    _getMonthTenureFlexipay(){
        axios.post(config.get('API_URL')+'/brandemi/get_month_tenure_flexipay',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((tenure, index) => {
                    //emi_tenure_code->TR008
                    //emi_tenure_code: "TR008"
                    //emi_tenure_display_name: "15 Days"
                    //emi_tenure_months: "15"
                    this.state.tenureList.push({value: tenure.emi_tenure_code, label: tenure.emi_tenure_display_name})
                });
            }
        });
    }

    _getAllMerchants(){
        axios.post(config.get('API_URL')+'/brandemi/get-merchant',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        });
    }

    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/brandemi/get-chain',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            //console.log(response.data);
            chalinList.push({value:'9', label: 'All'})
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name, value1: chain.merchant_code, merch_name: chain.merchant_name})
            });

            this.setState({
                chainList:chalinList
            })
        });
    }

    openDecampaignModel(id, merchant_name,merchant_code, chain_name,chain_code, store_name,store_code, bank_name,bank_code, tennure_name,tennure_code, tid) {
            this.setState({
            id: id,
            merchantID:merchant_code,
            merchantName:merchant_name,
            merchantValue:{value: merchant_code, label: merchant_name},
            chainID:chain_code,
            chainName:chain_name,
            chainValue:{value: chain_code, label: chain_name},
            storeID:store_code,
            storeName:store_name,
            storeValue:{value: store_code, label: store_name},
            bankID:bank_code,
            bankName:bank_name,
            bankValue:{value: bank_code, label: bank_name},
            tenureID:tennure_code,
            tenureName:tennure_name,
            tenureValue:{value: tennure_code, label: tennure_name},
            tid: tid,
            campaignDeconfirmationModel2: true
        });
    }

    addConfig() {
        this.setState({
            isSubmit: true,
            loading: true,
            add_disable: true
        });
        let kill = 0;
        if(this.state.merchantID == null || this.state.merchantID == ''){
            this.handleNotificationClick("tr", 3, "Select merchant");
            kill = 1;
        }
//         else if(this.state.chainID == null || this.state.chainID == ''){
//             this.handleNotificationClick("tr", 3, "Select Chain");
//             kill = 1;
//         }
//         else if(this.state.storeID == null || this.state.storeID == ''){
//             this.handleNotificationClick("tr", 3, "Select Store");
//             kill = 1;
//         }
        else if(this.state.bankID == null || this.state.bankID == ''){
            this.handleNotificationClick("tr", 3, "Select Bank");
            kill = 1;
        }
        else if(this.state.tenureID == null || this.state.tenureID == ''){
            this.handleNotificationClick("tr", 3, "Select Tenure");
            kill = 1;
        }
        else if(this.state.tid == null || this.state.tid == ''){
            this.handleNotificationClick("tr", 3, "Add TID");
            kill = 1;
        }
        if (kill == 0){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const data1 = new FormData();
        data1.append('user_id', decoded._id);;
        data1.append('merchant_name', JSON.stringify(this.state.merchantName));
        data1.append('merchant_code', JSON.stringify(this.state.merchantID));
        data1.append('chain_name', JSON.stringify(this.state.chainName));
        data1.append('chain_code', JSON.stringify(this.state.chainID));
        data1.append('store_name', JSON.stringify(this.state.storeName));
        data1.append('store_code', JSON.stringify(this.state.storeID));
        data1.append('bank_name', JSON.stringify(this.state.bankName));
        data1.append('bank_code', JSON.stringify(this.state.bankID));
        data1.append('tenure_name', JSON.stringify(this.state.tenureName));
        data1.append('tenure_code', JSON.stringify(this.state.tenureID));
        data1.append('tid', JSON.stringify(this.state.tid));
        // Display the key/value pairs
//         for (var pair of data1.entries()) {
//             console.log(pair[0]+ ', ' + pair[1]);
//         }
        axios.post(config.get('API_URL') + "/brandemi/add_merchant_mapping_tid", data1,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                //console.log(res);
                if (res.data.flag == '-1'){
                    this.handleNotificationClick("tr", 3, "Configuration for this chain already exists.");
                }
                else if (res.data.flag == '1'){
                    this.handleNotificationClick("tr", 1, "Configuration added");
                    // let url = '/admin/merchant-master';
                    // console.log(url);
                    // this.props.history.push(url);
                    this.getMerchantMappingData();
                    this.toggleDecampaignModel();
                }
                else if (res.data.flag == '0'){
                    this.handleNotificationClick("tr", 3, "Something Wrong");
                }
                else if (res.data.flag == '2'){
                    this.handleNotificationClick("tr", 3, "Entry already exists for given merchant/chain/store");
                }
                else if (res.data.flag == '3'){
                    this.handleNotificationClick("tr", 3, "API error");
                }
                this.setState({
                    loading: false,
                    add_disable: false
                });
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })
        }
        else{
            this.setState({
                loading: false,
                add_disable: false
            });
        }
    }

    editConfig() {
        this.setState({
            isSubmit: true,
            loading: true,
            edit_disable: true
        });
        let kill = 0;
        if(this.state.merchantID == null || this.state.merchantID == ''){
            this.handleNotificationClick("tr", 3, "Select merchant");
            kill = 1;
        }
//         else if(this.state.chainID == null || this.state.chainID == ''){
//             this.handleNotificationClick("tr", 3, "Select Chain");
//             kill = 1;
//         }
//         else if(this.state.storeID == null || this.state.storeID == ''){
//             this.handleNotificationClick("tr", 3, "Select Store");
//             kill = 1;
//         }
        else if(this.state.bankID == null || this.state.bankID == ''){
            this.handleNotificationClick("tr", 3, "Select Bank");
            kill = 1;
        }
        else if(this.state.tenureID == null || this.state.tenureID == ''){
            this.handleNotificationClick("tr", 3, "Select Tenure");
            kill = 1;
        }
        else if(this.state.tid == null || this.state.tid == ''){
            this.handleNotificationClick("tr", 3, "Add TID");
            kill = 1;
        }
        if (kill == 0){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data1 = new FormData();
        //chalinList.push({value: chain.chain_code, label: chain.chain_name, value1: chain.merchant_code, merch_name: chain.merchant_name})
        data1.append('id', this.state.id);
        data1.append('user_id', decoded._id);;
        data1.append('merchant_name', JSON.stringify(this.state.merchantName));
        data1.append('merchant_code', JSON.stringify(this.state.merchantID));
        data1.append('chain_name', JSON.stringify(this.state.chainName));
        data1.append('chain_code', JSON.stringify(this.state.chainID));
        data1.append('store_name', JSON.stringify(this.state.storeName));
        data1.append('store_code', JSON.stringify(this.state.storeID));
        data1.append('bank_name', JSON.stringify(this.state.bankName));
        data1.append('bank_code', JSON.stringify(this.state.bankID));
        data1.append('tenure_name', JSON.stringify(this.state.tenureName));
        data1.append('tenure_code', JSON.stringify(this.state.tenureID));
        data1.append('tid', JSON.stringify(this.state.tid));
        //console.log(data1);
        axios.post(config.get('API_URL') + "/brandemi/edit_merchant_mapping_tid", data1,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
               // console.log(res);
                if (res.data.flag == '-1'){
                    this.handleNotificationClick("tr", 3, "Configuration for this chain already exists.");
                }
                else if (res.data.flag == '1'){
                    this.handleNotificationClick("tr", 1, "Configuration edited");
                    this.getMerchantMappingData();
                    this.toggleDecampaignModel2();
                }
                else if (res.data.flag == '0'){
                    this.handleNotificationClick("tr", 3, "Something Wrong");
                }
                else if (res.data.flag == '4'){
                    this.handleNotificationClick("tr", 2, "Records are Identical");
                }

                this.setState({
                    loading: false,
                    edit_disable: false
                });
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })
        }
        else{
            this.setState({
                loading: false,
                edit_disable: false
            });
        }


    }


    deleteMerchantMapping(merchant_tid_code) {
        confirmAlert({
            title: 'Question',
            message: 'Are you sure you want to delete ?.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.setState({
                        loading: true
                    });
                    //console.log("Delete ID is : ",id)
                    //console.log("Merchant T ID is : ",merchant_tid_code)
                    var data = {
                        merchant_tid_code:merchant_tid_code
                    }
                        axios.post(config.get('API_URL') + "/brandemi/delete_merchant_mapping_tid", data,{
                        headers: {
                            Authorization: ` ${localStorage.usertoken}`
                        }
                    }).then(response => {
                        this.handleNotificationClick("tr", 1, "Record Deleted Successfully.");
                        this.getMerchantMappingData();
                    })
                }
            },
                {
                    label: 'No',
                }
            ]
        });
    }


    handleChange(checked) {
        //console.log(this.state.checked);
        //console.log(e.target.value);
        this.setState({
            checked
        });
        //this.setState({
        //    changedItems: {...this.state.changedItems, [id]:e.target.value},
        //    isChange: true
        //});
    }

    getMerchantMappingData(){
        this.setState({
            loading: true
        });
            if ($.fn.DataTable.isDataTable('#merchant_showTable')) {
                $('#merchant_showTable').DataTable().destroy();
            }
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            axios.get(config.get('API_URL') + '/brandemi/view_merchant_mapping_tid',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            }).then(response => {
//                 console.log("Data : ",response.data);
                this.setState({
                    merchant_mapping_table_data: response.data
                    //merchant2_display_data: response.data
                });
                $('#merchant_showTable').DataTable({
                    "oLanguage": {
                        "sEmptyTable": "There are no merchants configured"
                    }
                });
                this.setState({
                    loading: false,
                    user_id: decoded._id
                });
            });
    }

    uploadDropdownHandler = () => {
        this.setState({
            uploadDropdown: true
        })
    }

    gotoCreateSchemes = () => {
        this.props.history.push('/admin/admin-new-create-schemes');
    }

    toggleErrorModel() {
        this.setState({
            errorModel: !this.state.errorModel
        });
    }

    toggleNoErrorModel() {
        this.setState({
            noErrorModel: !this.state.noErrorModel
        });
    }

    toggleDecampaignModel() {
        this.setState({
            chainList:[],
            storeList:[],
            merchantID:'',
            merchantValue:'',
            merchantName:'',
            chainID:'',
            chainValue:'',
            chainName:'',
            storeID:'',
            storeValue:'',
            storeName:'',
            bankID:'',
            bankValue:'',
            bankName:'',
            tenureID:'',
            tenureValue:'',
            tenureName:'',
            tid:'',
            campaignDeconfirmationModel: !this.state.campaignDeconfirmationModel
        });
    }

    toggleDecampaignModel2() {
        this.setState({
            campaignDeconfirmationModel2: !this.state.campaignDeconfirmationModel2
        });
    }

    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/brandemi/get-store', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            //console.log(response.data);
            storeList.push({value:'9', label: 'All'})
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name, value1:store.merchant_code, value2: store.chain_code, chain_name: store.chain_name, merch_name: store.merchant_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }

    //BANK_LIST: Selects the option selected from dropdown
    changeBankList(optionSelected) {
    console.log(optionSelected)
        this.setState({
            bankID: optionSelected.value,
            bankName: optionSelected.label,
            bankValue:optionSelected,
            field_1: optionSelected.value
        });
    }

    //TENURE_LIST: Selects the option selected from dropdown
    changeTenureList(optionSelected) {
        this.setState({
            tenureID: optionSelected.value,
            tenureName: optionSelected.label,
            tenureValue:optionSelected,
            field_1: optionSelected.value
        });
    }


    changeStore(optionSelected) {
        this.setState({
            storeID: optionSelected.value,
            storeName: optionSelected.label,
            storeValue:optionSelected,
            field_1: optionSelected.value
        });
    }

    changeMerchant1(optionSelected){
        this.setState({
            merchantID:optionSelected.value,
            merchantName:optionSelected.label,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            field_1: optionSelected.value
        }, () =>{
            this.getChain(optionSelected.value, 'merchant', this.state.object_type, this.state.object_code);
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
    }

    changeChain(optionSelected) {
        this.setState({
            chainID: optionSelected.value,
            chainValue:optionSelected,
            chainName:optionSelected.label,
            storeID:'',
            storeValue: [],
            field_1: optionSelected.value
        }, () => {
            this.getStore(optionSelected.value, 'chain', this.state.object_type, this.state.object_code);
        });
    }



    render() {
        //console.log(this.state.party_master_name);
        //console.log(this.state.party_master_id);
        //let party_render = this.state.party_options;
        //let party_render_list = this.state.party_list;
       // console.log(this.state.table_header_data);
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "37px",
                margin: "0px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px",
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px",
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "15px",
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px',
            }),
            menu: styles => ({ ...styles, zIndex: 999})
        };
        
        let default_table_headers = () =>{
            return(
                <thead>
                    <tr>
                        <th>Merchant Name</th>
                        <th>Merchant Code</th>
                        <th>Chain Name</th>
                        <th>Chain Code</th>
                        <th>Store Name</th>
                        <th>Store Code</th>
                        <th>Bank Name</th>
                        <th>Bank Code</th>
                        <th>Tenure Name</th>
                        <th>Tenure Code</th>
                        <th>TID</th>
                        <th>Merchant TID Code</th>
                        <th>Created Date</th>
                        <th>Latest Version</th>
                        <th>Version</th>
                        <th>Action</th>
                    </tr>
                </thead>
        )
        }
        let table_headers = default_table_headers();

        let table_headers_configured  = () =>{
            let value = this.state.table_header_data[0];
            return(
                <thead>
                    <tr>
                        <th>Merchant Name</th>
                        <th>Merchant Code</th>
                        <th>Chain Name</th>
                        <th>Chain Code</th>
                        <th>Store Name</th>
                        <th>Store Code</th>
                        <th>Bank Name</th>
                        <th>Bank Code</th>
                        <th>Tenure Name</th>
                        <th>Tenure Code</th>
                        <th>TID</th>
                        <th>Merchant TID Code</th>
                        <th>Created Date</th>
                        <th>Latest Version</th>
                        <th>Version</th>
                        <th>Action</th>
                    </tr>
                </thead>
            )
        }

        if(this.state.selected_party != null){
            table_headers = table_headers_configured();
        }

{/*         let brand_file_data = this.state.merchant2_display_data.map((value, index) =>{ */}
        let table_data = this.state.merchant_mapping_table_data.map((value, index) =>{
            return (
                <tr key={index + 1}>
                    <td>{value.merchant_name}</td>
                    <td>{value.merchant_code}</td>
                    <td>{value.chain_name}</td>
                    <td>{value.chain_code}</td>
                    <td>{value.store_name}</td>
                    <td>{value.store_code}</td>
                    <td>{value.bank_name}</td>
                    <td>{value.bank_code}</td>
                    <td>{value.tennure_name}</td>
                    <td>{value.tennure_code}</td>
                    <td>{value.tid}</td>
                    <td>{value.merchant_tid_code}</td>
                    <td>{value.record_timestamp}</td>
                    <td>{value.latest_version}</td>
                    <td>{value.version}</td>
                    <td>
                    <Link className="viewButton" data-tip="Edit Configuration" onClick={this.openDecampaignModel.bind(this,value.id,value.merchant_name,value.merchant_code,value.chain_name,value.chain_code,value.store_name,value.store_code,value.bank_name,value.bank_code,value.tennure_name,value.tennure_code,value.tid)}><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link> <br /><br />
                    <Link className="viewButton" data-tip="Delete Configuration" onClick={this.deleteMerchantMapping.bind(this,value.merchant_tid_code)}><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></Link>
                    </td>
                </tr>
            )
        });

        return (
<div className="content-invoice">
   <CommonNavbar/>
   <Modal isOpen={this.state.campaignDeconfirmationModel}
      toggle={this.toggleDecampaignModel.bind(this)}
      size = "lg"
      >
      <ModalBody>
         <div className="row">
            <div className="col-xs-12 ">
               <h4 className="modalh4">Add Configuration</h4>
            </div>
         </div>
         <div className="row">
            <div className="col-md-4">
               <Label>Select Merchant:</Label>
               <Select name={"merchant_selector"}
                  components={{ MenuList }}
                  isClearable={false}
                  onChange={this.changeMerchant1.bind(this)}
                  className="report-listbox"
                  options={this.state.merchantList}
                  value={this.state.merchantValue}
                  placeholderButtonLabel="All"
                  />
            </div>
            <div className="col-md-4">
               <Label>Select Chain:</Label>
               <Select name={"chain_selector"}
                  components={{ MenuList }}
                  isClearable={false}
                  onChange={this.changeChain.bind(this)}
                  className="report-listbox"
                  options={this.state.chainList}
                  value={this.state.chainValue}
                  placeholderButtonLabel="All"
                  />
            </div>
            <div className="col-md-4">
               <Label>Select Store:</Label>
               <Select name={"store_selector"}
                  components={{ MenuList }}
                  isClearable={false}
                  onChange={this.changeStore.bind(this)}
                  className="report-listbox"
                  options={this.state.storeList}
                  value={this.state.storeValue}
                  placeholderButtonLabel="All"
                  />
            </div>
         </div>
         <div className="row">
            <div className="col-md-4">
               <Label>Select Bank:</Label>
               <Select
                  name = {"bank_selector"}
                  components={{ MenuList }}
                  onChange={this.changeBankList.bind(this)}
                  isClearable={false}
                  className="report-listbox"
                  options={this.state.bankList}
                  value={this.state.bankValue}
                  placeholderButtonLabel="All"
                  />
            </div>
            <div className="col-md-4">
               <Label>Select Tenure:</Label>
               <Select
                  name = {"tenure_selector"}
                  components={{ MenuList }}
                  onChange={this.changeTenureList.bind(this)}
                  isClearable={false}
                  className="report-listbox"
                  options={this.state.tenureList}
                  value={this.state.tenureValue}
                  placeholderButtonLabel="All"
                  />
            </div>
            <div className="col-md-4">
               <Label>Enter TID:</Label>
               <Input id="tid"
                  placeholder="Enter TID"
                  className="maxheighter"
                  onChange={(e)=> {
               let {tid} = this.state;
               tid = e.target.value;
               this.setState({
               tid: tid
               })
               }}/>
            </div>
         </div>
         <br/>
         <ModalFooter>
            <Button color="primary" disabled={this.state.add_disable} className="btn btn-primary btn-capitalize" onClick={this.addConfig.bind(this)}>Add Configuration</Button>{' '}
            <Button color="secondary" className="btn-capitalize2" onClick={this.toggleDecampaignModel.bind(this)}>Cancel</Button>
         </ModalFooter>
      </ModalBody>
   </Modal>
   {/* EDIT MODAL START */}
   <Modal isOpen={this.state.campaignDeconfirmationModel2}
      toggle={this.toggleDecampaignModel2.bind(this)}
      size = "lg"
      >
      <ModalBody>
         <div className="row">
            <div className="col-xs-12 ">
               <h4 className="modalh4">Update Configuration</h4>
            </div>
         </div>
         <div className="row">
            <div className="col-md-4">
               <Label>Select Merchant:</Label>
               <Select name={"merchant_selector"}
                  components={{ MenuList }}
                  isClearable={false}
                  onChange={this.changeMerchant1.bind(this)}
                  className="report-listbox"
                  options={this.state.merchantList}
                  value={this.state.merchantValue}
                  placeholderButtonLabel="All"
                  />
            </div>
            <div className="col-md-4">
               <Label>Select Chain:</Label>
               <Select name={"chain_selector"}
                  components={{ MenuList }}
                  isClearable={false}
                  onChange={this.changeChain.bind(this)}
                  className="report-listbox"
                  options={this.state.chainList}
                  value={this.state.chainValue}
                  placeholderButtonLabel="All"
                  />
            </div>
            <div className="col-md-4">
               <Label>Select Store:</Label>
               <Select name={"store_selector"}
                  components={{ MenuList }}
                  isClearable={false}
                  onChange={this.changeStore.bind(this)}
                  className="report-listbox"
                  options={this.state.storeList}
                  value={this.state.storeValue}
                  placeholderButtonLabel="All"
                  />
            </div>
         </div>
         <div className="row">
            <div className="col-md-4">
               <Label>Select Bank:</Label>
               <Select
                  name = {"bank_selector"}
                  components={{ MenuList }}
                  onChange={this.changeBankList.bind(this)}
                  isClearable={false}
                  className="report-listbox"
                  options={this.state.bankList}
                  value={this.state.bankValue}
                  placeholderButtonLabel="All"
                  />
            </div>
            <div className="col-md-4">
               <Label>Select Tenure:</Label>
               <Select
                  name = {"tenure_selector"}
                  components={{ MenuList }}
                  onChange={this.changeTenureList.bind(this)}
                  isClearable={false}
                  className="report-listbox"
                  options={this.state.tenureList}
                  value={this.state.tenureValue}
                  placeholderButtonLabel="All"
                  />
            </div>
            <div className="col-md-4">
               <Label>Enter TID:</Label>
               <Input id="tid"
                  className="maxheighter"
                  value={this.state.tid}
                  onChange={(e)=> {
               let {tid} = this.state;
               tid = e.target.value;
               this.setState({
               tid: tid
               })
               }}/>
            </div>
         </div>
         <br/>
         <ModalFooter>
            <Button color="primary" disabled={this.state.edit_disable} className="btn btn-primary btn-capitalize" onClick={this.editConfig.bind(this)}>Edit Configuration</Button>{' '}
            <Button color="secondary" className="btn-capitalize2" onClick={this.toggleDecampaignModel2.bind(this)}>Cancel</Button>
         </ModalFooter>
      </ModalBody>
   </Modal>
   {/* EDIT MODAL END */}
   <div className="container-fluid">
      <div className="row">
         <div className="col-md-12">
            <div className="card">

               <NotificationSystem ref="notificationSystem" style={style} />
               <ReactTooltip />
               <div className='sweet-loading'>
                  <BeatLoader
                     css={override}
                     sizeUnit={"px"}
                     size={20}
                     color={'#123abc'}
                     loading={this.state.loading}
                     />
               </div>
               <div className="col-md-9 no-padd">
                  <div className="header">
                     <h4 className="title">Merchant TID Mapping</h4>
                     <p className="category"></p>
                  </div>
               </div>
               <div className="header">
                  <button onClick={this.toggleDecampaignModel.bind(this)} className="btn btn-primary btn-capitalize pull-right">Add New Configuration</button>
               </div>
               <div className="clearfix"></div>
               <div className="table-responsive">
                  <table className="table table-striped table-hover" id="merchant_showTable">
                     {table_headers}
                     <tbody>
                        {table_data}
                     </tbody>
                  </table>
               </div>
               <div className="footer">
                  <div className="stats"><i></i>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
        );
    }
}

export default MerchantBrandIntegration;